import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../types';
import { logsSearchSchema } from '../../../../../views/Logs/Logs.search-schema';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/logs/')({
  validateSearch: zodValidator(logsSearchSchema),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.LOGS });
    context.validatePermissions({ isAllowed, preload });
  },
});
